import css from './ConnectorSvg.scss';

const POINT_NAME = {
	p1: 'p1',
	p2: 'p2',
} as const;

const POINT_STATE = {
	connected: css.connected,
	connecting: css.connecting,
	highlight: css.highlight,
	showStart: css.showStart,
	showEnd: css.showEnd,
};

const DEFAULT_POINT_RADIUS = 5;
const DRAG_HALO_RADIUS = 12;
const DRAG_ACTIVATION_DISTANCE = 8;

export { POINT_NAME, POINT_STATE, DEFAULT_POINT_RADIUS, DRAG_HALO_RADIUS, DRAG_ACTIVATION_DISTANCE };
